import CertificateTypes, {
  isVtjOteTodistus,
} from 'todistukset-common/src/vtj/CertificateTypes.enum'
import PageRoutes from 'todistukset-ui/src/vtj/todistukset-page-routes.enum'

enum OrderFlowName {
  ASUINPAIKKATODISTUS = CertificateTypes.ASUINPAIKKATODISTUS,
  ELOSSAOLOTODISTUS = CertificateTypes.ELOSSAOLOTODISTUS,
  AVIOLIITTOTODISTUS = CertificateTypes.AVIOLIITTOTODISTUS,
  SIVIILISAATYTODISTUS = CertificateTypes.SIVIILISAATYTODISTUS,
  SYNTYMATODISTUS = CertificateTypes.SYNTYMATODISTUS,
  AETTODISTUS_ORDERER = PageRoutes.AETTODISTUS_ORDERER,
  AETTODISTUS_SIGNER = PageRoutes.AETTODISTUS_SIGNER,
  UAETTODISTUS = CertificateTypes.UAETTODISTUS,
}

export const orderFlowNameToCertificateType = (
  orderFlowName: OrderFlowName
): CertificateTypes => {
  switch (orderFlowName) {
    case OrderFlowName.ASUINPAIKKATODISTUS:
    case OrderFlowName.ELOSSAOLOTODISTUS:
    case OrderFlowName.AVIOLIITTOTODISTUS:
    case OrderFlowName.SIVIILISAATYTODISTUS:
    case OrderFlowName.SYNTYMATODISTUS:
      if (!isVtjOteTodistus(orderFlowName)) {
        throw new Error(
          'Type check failed for "orderFlowName". Should be VtjOteTodistusType here.'
        )
      }
      return orderFlowName
    case OrderFlowName.AETTODISTUS_ORDERER:
    case OrderFlowName.AETTODISTUS_SIGNER:
      return CertificateTypes.AETTODISTUS
    case OrderFlowName.UAETTODISTUS:
      return CertificateTypes.UAETTODISTUS
  }
}

export default OrderFlowName
